/* Cart gift picker — pairs with snippets/cart-gift-picker.liquid */
if (!customElements.get('gift-picker')) {
  const GP_REMOVED_KEY = 'gift_picker_removed';
  let gpBusy = false;

  class GiftPicker extends HTMLElement {
    connectedCallback() {
      this.active = this.dataset.active === 'true';
      this.eligible = this.dataset.eligible === 'true';

      try {
        this.lines = JSON.parse(this.querySelector('[data-gift-lines]')?.textContent || '[]');
      } catch (e) {
        this.lines = [];
      }

      this.querySelectorAll('[data-gift-card]').forEach(card => {
        card.addEventListener('click', () => this.onCardClick(card));
      });

      this.showRemovedNotice();
      this.reconcile();
    }

    /* Keep gift lines valid: max one line, qty 1, only while active and eligible */
    reconcile() {
      if (gpBusy || !this.lines.length) return;

      const updates = {};
      if (!this.active || !this.eligible) {
        this.lines.forEach(line => (updates[line.key] = 0));
        if (this.active) this.setFlag(GP_REMOVED_KEY);
      } else {
        this.lines.forEach((line, i) => {
          if (i > 0) updates[line.key] = 0;
          else if (line.qty !== 1) updates[line.key] = 1;
        });
      }

      if (Object.keys(updates).length) {
        this.request(this.url('cart_update_url', '/cart/update'), { updates });
      }
    }

    async onCardClick(card) {
      if (gpBusy || card.getAttribute('aria-disabled') === 'true') return;

      const variantId = Number(card.dataset.variantId);
      const current = this.lines[0];
      this.clearError();
      card.classList.add('is-loading');

      // Clicking the selected gift removes it
      if (current && current.variant === variantId) {
        await this.request(this.url('cart_update_url', '/cart/update'), { updates: { [current.key]: 0 } });
        return;
      }

      // Swap: remove existing gift lines first, then add the new one
      if (this.lines.length) {
        const updates = {};
        this.lines.forEach(line => (updates[line.key] = 0));
        const ok = await this.request(this.url('cart_update_url', '/cart/update'), { updates }, false);
        if (!ok) return;
      }

      await this.request(this.url('cart_add_url', '/cart/add'), {
        items: [{ id: variantId, quantity: 1, properties: { _gift: '1' } }]
      });
    }

    async request(url, payload, render = true) {
      gpBusy = true;
      this.setLoading(true);

      const cartDrawer = document.querySelector('cart-drawer');
      const sections = typeof sectionsToRender !== 'undefined' ? sectionsToRender : [];
      const body = render && sections.length
        ? { ...payload, sections: sections.map(s => s.section), sections_url: window.location.pathname }
        : payload;

      try {
        const response = await fetch(`${url}.js`, { ...fetchConfig(), body: JSON.stringify(body) });
        const data = await response.json();

        if (!response.ok || data.status || data.errors) {
          this.showError(data.description || data.message || data.errors);
          return false;
        }

        if (render) {
          if (cartDrawer && data.sections) {
            cartDrawer.renderContents(data, false);
          } else {
            window.location.reload();
          }
          if (typeof updateFreeShipping === 'function') updateFreeShipping();
        }
        return true;
      } catch (error) {
        console.error('Gift picker:', error);
        this.showError();
        return false;
      } finally {
        gpBusy = false;
        if (this.isConnected) this.setLoading(false);
      }
    }

    url(key, fallback) {
      return (window.routes && window.routes[key]) || fallback;
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      this.closest('cart-drawer-items')?.classList.toggle('is-loading', state);
      if (!state) this.querySelectorAll('.is-loading').forEach(el => el.classList.remove('is-loading'));
    }

    showRemovedNotice() {
      if (!this.consumeFlag(GP_REMOVED_KEY) || this.eligible) return;
      const status = this.querySelector('[data-gp-status]');
      const removed = this.querySelector('[data-gp-removed]');
      if (!status || !removed) return;
      status.hidden = true;
      removed.hidden = false;
    }

    showError(message) {
      const el = this.querySelector('[data-gp-error]');
      if (!el) return;
      el.textContent = typeof message === 'string' && message ? message : (window.cartStrings?.error || 'Error');
      el.hidden = false;
    }

    clearError() {
      const el = this.querySelector('[data-gp-error]');
      if (el) el.hidden = true;
    }

    setFlag(key) {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }

    consumeFlag(key) {
      try {
        const value = sessionStorage.getItem(key);
        sessionStorage.removeItem(key);
        return value === '1';
      } catch (e) {
        return false;
      }
    }
  }

  customElements.define('gift-picker', GiftPicker);
}
